var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 8.81 1 22.052l5.117 3.01 7.626-13.444 4.816.6V6h-7.627c-.963 0-1.94 1.873-2.308 2.81zM1.602 6v6.22c.77 0 2.629-.32 3.913-1.605C6.8 9.331 7.722 7.003 8.023 6h-6.42zM9.93 25.063v-5.618h4.816l7.023-11.64c.167-.6.822-1.805 2.106-1.805H30.9v6.22h-4.917c-.642 0-4.682 7.492-6.622 11.238-.4.535-1.424 1.605-2.307 1.605H9.93zm18.01-3.21a3.06 3.06 0 1 0 0-6.12 3.06 3.06 0 0 0 0 6.12z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTru);
export default __webpack_public_path__ + "static/media/TRU.6fce5b1b1dbbc3a5adaa798613f6bd69.svg";
export { ForwardRef as ReactComponent };